import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", { d: "M7.538 4.43c-.127 0-.226.091-.226.191v10.21l-1.36 1.359V4.63c0-.851.716-1.549 1.586-1.549h2.038v-.616c0-.616.508-1.114 1.133-1.114h2.718c.625 0 1.132.498 1.132 1.114v.616h2.038c.67 0 1.25.408 1.477.987l-1.25 1.25V4.63c0-.109-.1-.19-.227-.19H13.2V2.71h-2.265v1.72H7.538Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M21.607 2.52a.684.684 0 0 1 .96 0 .684.684 0 0 1 0 .96l-4.384 4.384V21.1c0 .852-.716 1.55-1.586 1.55h-9.06c-.869 0-1.585-.698-1.585-1.55v-1.005l-2.328 2.328a.672.672 0 0 1-.48.2.672.672 0 0 1-.48-.2.684.684 0 0 1 0-.96L21.607 2.518Zm-5.01 18.761c.127 0 .227-.09.227-.19V9.223L7.31 18.727v2.364c0 .109.1.19.227.19h9.06Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function d(h, s) {
  return t(), c("svg", o, [...r]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
